import script from "./SearchTargetUserAndSend.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchTargetUserAndSend.vue?vue&type=script&setup=true&lang=js"

import "./SearchTargetUserAndSend.vue?vue&type=style&index=0&id=e0754f76&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0754f76"]])

export default __exports__